export enum ApiPortfolioState {
  Unknown = 0,

  // States for Lesson/xAPI
  LessonBase = 1,
  LessonStart = 2,

  // States for Quiz
  QuizBase = 10,
  QuizStart = 11,
  QuizLock = 12,

  // States for Assessment
  AssessmentBase = 20,
  AssessmentStart = 21,
  AssessmentSubmit = 22,
  AssessmentMark = 23,
  AssessmentRetry = 24,
  AssessmentLock = 25
}
